import _ from 'lodash'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { useLayout } from '../../hooks/resourceHooks'
import { useIdaps, useIsLoading } from '../../hooks/idapsHooks'
import { fetchResources } from '../../store/modules/resources/actions'
import Error from './../_error'
import { actions as idapsActions } from '../../store/modules/idaps'
import Loader from 'components/Loader'
import DrugCategories from '../../containers/DrugCategories'
import { WithContentfulPage } from '../../components/WithContentfulPage'
const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 15px;
`

const DynamicContentfulPage = () => {
  const layout = useLayout()
  const dispatch = useDispatch()
  const idapsDrugs = useIdaps()
  const idapsLoading = useIsLoading()
  const { showNewIdaps } = layout

  useEffect(() => {
    if (showNewIdaps && idapsDrugs.length === 0) {
      dispatch(idapsActions.fetchIdaps({provider: 'sisense'}))
    }
  }, [idapsDrugs, showNewIdaps])


  return (
    <>     
    {showNewIdaps && idapsLoading ? 
        <LoadingContainer>
          <Loader />
        </LoadingContainer> : 
        idapsDrugs.length > 0 &&
          <DrugCategories
            drugItems={idapsDrugs}
            parentPathName="idaps"
            pathKey="name"
            publicNameKey="publicName"
          />
      }
    </>
  )
}
DynamicContentfulPage.getInitialProps = async ({ store: { dispatch }}) => {
  const pathname = 'iDAPs'
  await dispatch(fetchResources({
    resourceType: 'page',
    requestKey: pathname,
    include:2, // includes embedded entries in rich text area
    where: {
      'fields.pageUrlName': pathname
    }
  }))

  return { pathname }
}

export default WithContentfulPage(DynamicContentfulPage)
